// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-text{
  padding-top: 18px;
  padding-left: 180px;
}
 
.title h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}

.mat-header-row .mat-header-cell {
  background-color: blue !important;
  color: blue !important; /* Optional: to make the text readable */
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
 
th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}
 
table th {
  background-color: #0b2d71;
  color: white;
  font-weight: bold;
}
 
td a {
  color: blue;
  text-decoration: none;
}
 
 
 
.progress-bar-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}
 
.progress-bar {
  height: 24px;
  border-radius: 4px;
}
 
.high-percentage {
  background-color: green !important;
}
 
.normal-percentage {
  background-color: green !important;
}
.button-container{
 
  row-gap: 10px;
  margin-top: 20px;
}
.go-button {
  margin-left: 300px;
  margin-top: -60px;
}
.row {
  margin-left: 5px;
}
 
 `, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/logs/logs.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB,EAAE,wCAAwC;AAClE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;;AAIA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;AACA;;EAEE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".search-text{\n  padding-top: 18px;\n  padding-left: 180px;\n}\n \n.title h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n\n.mat-header-row .mat-header-cell {\n  background-color: blue !important;\n  color: blue !important; /* Optional: to make the text readable */\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n \nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n \ntable th {\n  background-color: #0b2d71;\n  color: white;\n  font-weight: bold;\n}\n \ntd a {\n  color: blue;\n  text-decoration: none;\n}\n \n \n \n.progress-bar-container {\n  width: 100%;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n \n.progress-bar {\n  height: 24px;\n  border-radius: 4px;\n}\n \n.high-percentage {\n  background-color: green !important;\n}\n \n.normal-percentage {\n  background-color: green !important;\n}\n.button-container{\n \n  row-gap: 10px;\n  margin-top: 20px;\n}\n.go-button {\n  margin-left: 300px;\n  margin-top: -60px;\n}\n.row {\n  margin-left: 5px;\n}\n \n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
